export const en = {
    'autobudget-priority': 'Priority',
    banners: 'Ads',
    'campaign-group': 'Campaign/Group',
    cpa: 'CPA, {currency}',
    cpc: 'CPC, {currency}',
    name: 'Name',
    price: 'Prices in ad',
    status: 'Status',
    'target-funnel': 'Target audience'
};
